import { AdminUiExportImportController } from './admin-ui-export-import.controller';

const AdminUiExportImport = () => {
  return <AdminUiExportImportController />;
};

export default AdminUiExportImport;
